// extracted by mini-css-extract-plugin
export var hidden = "styles-module--hidden--3VOoC";
export var menuButton = "styles-module--menuButton--c2Mu9";
export var mobileNavigation = "styles-module--mobileNavigation--23SRX";
export var navItem = "styles-module--navItem--2JaEe";
export var navbar = "styles-module--navbar--1eiHD";
export var navigation = "styles-module--navigation--1ULOE";
export var searchButton = "styles-module--searchButton--S5_5V";
export var stackOnSmallScreens = "styles-module--stackOnSmallScreens--3OMO5";
export var visible = "styles-module--visible--1zIrA";